module.exports = __webpack_public_path__ + "img/VetoSansCond-LightItalic.4e80562c.svg";